import React, { Component } from 'react';
import './MainWindow.css';
import Header from "./Header";
import { Map } from 'treemindmap';

import CookieConsent from "react-cookie-consent"


class MainWindow extends Component {

    constructor(props) {
        super(props);
        this.state={map:"",
                    downloadLink:""}
    }

    getParam(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }


    componentDidMount() {
        this.setInitialMap();
    }

    setInitialMap()
    {
        this.setState({map:<Map stateHandler={(data)=>{
                                    //this.setState({currentData:JSON.stringify(data)});
                                    this._setDownloadLink(JSON.stringify(data))
                                    //console.log(JSON.stringify(data))
                                }}/>})

    }
    setInitialMapWithFireBase(initialData)
    {
        this.setState({map:<Map initialState={initialData}
                                stateHandler={(data)=>{
                                    //this.setState({currentData:JSON.stringify(data)});
                                    this._setDownloadLink(JSON.stringify(data))
                                    this.database.writeData(data)
                                }}/>})
    }



    _loadFromFile(event)
    {
        let file = event.target.files[0]
        if (file!=null)
        {
            let reader = new FileReader()
            reader.onloadend = () => {
                this.setState({map:"",downloadLink:""})
                let importedData=reader.result
                let newMap =<Map initialState={importedData}
                                 stateHandler={(data)=>{
                                     this._setDownloadLink(JSON.stringify(data))
                                     //this.database.writeData(data)
                                    }
                                 }
                            />
                this.setState({map:newMap})
            }
            reader.readAsText(file)
        }
    }


    _setDownloadLink(data)
    {
        //let blob = new Blob([ this.state.currentData ], { "type" : "text/plain" });
        let blob = new Blob([ data ], { "type" : "text/plain" });
        this.setState({downloadLink:window.URL.createObjectURL(blob)})
    }

    render() {
    return (
        <div>
            <Header open={(event=>{this._loadFromFile(event)})}
                    downloadLink={this.state.downloadLink}/>
            {this.state.map}

            <CookieConsent enableDeclineButton declineButtonStyle={{background:'grey'}} flipButtons={true}>
                This website uses cookies to understand the site usage. We'll assume you're ok with this, but you can opt-out if you wish.
            </CookieConsent>
        </div>
    );
    }
}

export default MainWindow;
